import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 获取工单列表
 */
export function getOrderList(data) {
  return fetch({
    url: '/annualInspection/pageList',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 获取提成列表
 */
export function getCommissionList(data) {
  return fetch({
    url: '/repair/manage/repair/order/commissionList',
    method: 'POST',
    data
  })
}


/**
 * @param {idList[]} data
 * 删除工单
 */
export function deleteOrder(data) {
  return fetch({
    url: '/annualInspection/deleteMaster',
    method: 'POST',
    data
  })
}


/**
 * @param {id} params
 * 导出PDF
 */
export function exportPDF(params) {
  return formAxios({
    url: '/maintain/manage/maintain/order/exportPdf',
    method: 'GET',
    params
  })
}



/**
 * @param {}
 * 导出EXAIL
 */
export function exportEXAIL(data) {
  return formAxios({
    url: '/repair/manage/repair/order/exportTemplateList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取部门列表
 */
export function getDepartmentTree(params) {
  return fetch({
    url: '/auth/department/getDepartmentTree',
    method: 'GET',
    params
  })
}


/**
 * @param {orderId} params
 *
 */
export function getOrderDetailInfo(params) {
  return fetch({
    url: '/app/annualInspection/detail',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 根据unitId和部门id获取项目
 */
export function getProjectLiftTree(params) {
  return fetch({
    url: '/maintain/project/projectLiftTree',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} params
 * 根据部门id获取部门详情
 */
export function getDepartmentDetail(params) {
  return fetch({
    url: '/auth/department/detail',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 获取项目
 */
export function getProjectSimpleList(data) {
  return fetch({
    url: '/maintain/project/simpleList',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 获取使用单位列表
 */
export function getPropertyUnitSimpleList(data) {
  return fetch({
    url: '/auth/subPlatform/propertyUnit/simpleList',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 指派
 */
export function saveAssign(data) {
  return fetch({
    url: '/annualInspection/assign',
    method: 'POST',
    data
  })
}





// WEBPACK FOOTER //
// ./src/api/AnnualInspection/index.js